export class Test {
  Id: string ="";
  TestCode: string="";
  Description: string = "";
  CanBeOrdered4Kits: boolean=false
}
